import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import styles from "./LearnSunnahFromScholars.module.css";
import TextSlider from "./TextSlider/TextSlider";
import AppImg from './app-img.jpg';
import Image from "next/image";
import { useEffect } from "react";
import { apiRequest } from "../../../utils/axiosInstance";
import { useState } from "react";


const LearnSunnahFromScholars = () => {
  const [statisticsInfo, setStatisticsInfo] = useState(null)
  useEffect(() => {
    getPlatformStatistics()
  },[])
  
  const getPlatformStatistics = async () => {
    
    try {
      const data = await apiRequest(
        "/getStatistics",
        "GET",
        null
      );

      if (!data?.error) {
        setStatisticsInfo(data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatWithPlus = (num = 0) => {
    const base = Math.floor(num / 100) * 100;
    if(num < 1000 || num == 1000 ){
      return num
    }
    return num > base ? `${base.toLocaleString()}+` : num.toLocaleString();
  };

  return (
    <div className={styles.Section}>

      <div className={styles.container}>

        <div className={styles.Header}>
          <div className={styles.TitleTop}>
            <div className={styles.Title}>Learn</div>
            <div className={styles.TitleRight}><TextSlider /></div>
          </div>
          <div className={styles.Title}>from scholars of our Deen</div>
        </div>

        <div className={styles.Box}>
          <div className={styles.Grid}>
            <div className={styles.Content}>
              <div className={styles.TitleSmall}>
                Welcome to Takbir
              </div>
              <p>Takbir is our proclamation of greatness of Allah SWT by learning and practicing the only accepted Deen (religion) for mankind.</p>
              <p>Takbir is a secured, simple and easy-to-use online learning platform for learners (knowledge seekers) and amazing Mu’allim (teachers) of our Deen.</p>
            </div>
          </div>

          <div className={styles.Grid}>
            <div className={styles.Content}>
              <div className={styles.TitleSmall}>
                Benefits
              </div>
              <div className={styles.Benefits} style={{ color: "#F7AD00" }}>Learn anything</div>
              <div className={styles.Benefits} style={{ color: "#F97AAD" }}>From anywhere</div>
              <div className={styles.Benefits} style={{ color: "#00DBFF" }}>Directly from scholars</div>
              <div className={styles.Benefits} style={{ color: "#F89540" }}>At your own pace</div>
              <div className={styles.Benefits} style={{ color: "#1DA0FF" }}>With 24/7 course access</div>
              <div className={styles.Benefits} style={{ color: "#A000FF" }}>At no monthly fees</div>
            </div>
          </div>
        </div>

        <div className={styles.Box}>
          <div className={styles.Grid}>

            <div className={styles.TitleSmall} style={{ textAlign: "center", display: "flex", justifyContent: "center", width: "100%" }}>
              Growth
            </div>

            <div className={styles.GrowthBox}>

              <div className={styles.GrowthList}>
                <div className={styles.GrowthNumber}>{formatWithPlus(statisticsInfo?.learners_number)}</div>
                <div className={styles.GrowthTitle}>Learners</div>
              </div>
              <div className={styles.Divider}></div>
              <div className={styles.GrowthList}>
                <div className={styles.GrowthNumber}>{formatWithPlus(statisticsInfo?.teachers_number)}</div>
                <div className={styles.GrowthTitle}>Teachers</div>
              </div>
              <div className={styles.Divider}></div>

              <div className={styles.GrowthList}>
                <div className={styles.GrowthNumber}>{formatWithPlus(statisticsInfo?.courses_number)}</div>
                <div className={styles.GrowthTitle}>Courses</div>
              </div>
              <div className={styles.Divider}></div>
              <div className={styles.GrowthList}>
                <div className={styles.GrowthNumber}>{formatWithPlus(statisticsInfo?.cities_number)}</div>
                <div className={styles.GrowthTitle}>Cities</div>
              </div>

            </div>
          </div>

        </div>

        <div className={styles.Box}>
          <div className={styles.Mobile} style={{
            marginBottom:"24px"
          }}>
            <div className={styles.AppimgBox}>
              <Image src={AppImg} alt="takbir app" />
            </div>
          </div>

          <div className={styles.Grid}>
            <div className={styles.ContentOuter}>
              <div className={styles.Content}>
                <div className={styles.TitleSmall}>
                  Mobile App
                </div>
                <div className={styles.MainTitle}>Takbir in your pocket.</div>
                <p>Seamless access to all courses, live classes, reminders, and progress tracking anytime, anywhere with the Takbir Mobile App.</p>

                {/* <div className={styles.ButtonBox}>
                <button
                  className={styles.BottomButton}
                  onClick={() => router.push("/search")}
                >
                  Watch video
                </button>
              </div> */}
              </div>
            </div>
          </div>
          <div className={styles.Desktop}>
            <div className={styles.AppimgBox}>
              <Image src={AppImg} alt="takbir app" />
            </div>
          </div>
        </div>




      </div>

    </div>
  );
};

export default LearnSunnahFromScholars;
